export default __webpack_public_path__ + "static/media/landing-illustration-1.014c83a5.JPG";